/**
 * Normalizes a value taken from data, an enum or free text into a single lowerCamelCase testID
 * segment. Idempotent, so an already-camelCase symbol passes through unchanged.
 */
export const key = (value: string): string => {
  const words =
    value
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .toLowerCase()
      .match(/[a-z0-9]+/g) ?? [];

  return words.map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))).join('');
};

/**
 * Sanitizes a domain code that is conventionally uppercase (flight number, airport code) into a
 * single testID segment, preserving its casing.
 */
export const code = (value: string): string => value.replace(/[^a-zA-Z0-9]/g, '');

/**
 * Appends parts to a caller-supplied testID root, or yields undefined when the caller supplied no
 * root. Shared components use this so they never invent an id of their own. Parts are used as given,
 * so pass values taken from data through `key` or `code` first.
 */
export const partTestId = (root: string | undefined, ...parts: string[]): string | undefined =>
  root ? [root, ...parts].join('.') : undefined;
